import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { ContractStructureController } from "./contract-structure.controller";
import { ContractPriceController } from "./contract-price.controller";

interface ContractCostViewProps extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	type: 'cost' | 'price';
	onModeChanged: (mode: ControlMode) => void;
	currencies: CurrencySummary[];
	supplier: SupplierSummary;
	generatePrices: (priceCurrency: CurrencySummary) => void;
	onMarketChange?: (market: number) => void;
	selectedMarket?: number;
	productType: number;
}

@observer
export class ContractCostView extends React.Component<ContractCostViewProps, any> {
	public constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.loadCurrency(this.props.supplier);
	}

	componentWillReceiveProps(nextProps: Readonly<ContractCostViewProps>, nextContext: any) {
		if (this.props.supplier != nextProps.supplier) {
			this.loadCurrency(nextProps.supplier);
		}
	}

	private loadCurrency(supplier: SupplierSummary) {
		const item: CostItem | PriceItem = this.props.model.dynamicProperties[this.props.type];
		let currencyId: number;
		if (item && item.elements && item.elements.length > 0) {
			const element = item.elements[0];
			if (element != null && element.market == null) {
				currencyId = element.currency;
			}
		}
		if (supplier && currencyId == null) {
			currencyId = supplier.defaultCurrencyId;
		}
		const currency = this.props.currencies.find(e => e.id == currencyId);
		if (this.currency != currency) {
			this.currency = currency;
		}
	}

	@observable
	private currency: CurrencySummary;

	@autobind
	private currencyChange(newVal: CurrencySummary) {
		const obj: CostItem | PriceItem = this.props.model.dynamicProperties[this.props.type];
		const items = obj.elements;
		for (const item of items) {
			item.currency = newVal.id;
		}
		this.currency = newVal;
	}

	public render() {
		const obj: CostItem | PriceItem = this.props.model.dynamicProperties[this.props.type];
		const items = obj.elements;
		return (
			<React.Fragment>
				<ContractStructureController
					productType={this.props.productType}
					mode={this.props.mode}
					model={obj.structure}
					onModeChanged={this.props.onModeChanged}
					setBusy={this.props.setBusy}
					type={this.props.type}
					contract={this.props.model}
					currency={this.currency}
					currencies={this.props.currencies}
					currencyChange={this.currencyChange}
					generatePrices={this.props.generatePrices}
					onMarketChange={this.props.onMarketChange}
					selectedMarket={this.props.selectedMarket}
					supplier={this.props.supplier}
				/>
				<ContractPriceController
					contract={this.props.model}
					mode={this.props.mode}
					model={items}
					onModeChanged={this.props.onModeChanged}
					setBusy={this.props.setBusy}
					type={this.props.type}
					currency={this.currency}
					currencies={this.props.currencies}
					selectedMarket={this.props.selectedMarket}
				/>
			</React.Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-cost.view.tsx